import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getEvents({page, size, sortOrder, fromDate, toDate, salesRegionId, salesTerritoryId, searchString}) {
    const params = {
        page,
        size,
        sortOrder,
    };
    if (fromDate) {
        params["fromDate"] = fromDate;
    }
    if (toDate) {
        params["toDate"] = toDate;
    }
    if (salesRegionId) {
        params["salesRegionId"] = salesRegionId;
    }
    if (salesTerritoryId) {
        params["salesTerritoryId"] = salesTerritoryId;
    }
    if (searchString) {
        params["searchString"] = searchString.trim();
    }
    const response = await axios({
        url: API_DOMAIN + "/api/v2/events/adminPortal",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params,
    });

    return {events: response.data, totalCount: parseInt(response.headers["x-total-count"])};
}
export async function getEventsToCSV({sortOrder, fromDate, toDate}) {
    const params = {
        sortOrder,
    };
    if (fromDate) {
        params["fromDate"] = fromDate;
    }
    if (toDate) {
        params["toDate"] = toDate;
    }
    const response = await axios({
        url: API_DOMAIN + "/api/v2/events/adminPortal/csv",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        responseType: "blob",
        params,
    });

    return response;
}

export async function updateEvent(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/events",
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}
